<ng-container *transloco="let t;">
    <ng-scrollbar autoHeightDisabled="false" visibility="hover" class="documentDetailTabMainContainer">
        <div class="mt-0 px-2 py-50">
           @for(group of documentData?.layout_settings?.groups; track group.name) {
                @if(group?.name === 'top_section'){
                    <app-top-section 
                        [group]="group" 
                        [formGroup]="topSectionForm"
                        [documentData]="documentData"
                        (updateDocument)="onDocumentTypeChange($event)"
                        [hasFullAccessToDocument]="hasFullAccessToDocument" 
                        [canEditDocument]="canEditDocument">
                    </app-top-section>
                }
                <div class="accordion-wrapper" *ngIf="group.name !== 'top_section'">
                    <div class="collapse-icon">  
                        <div ngbAccordion #accordion="ngbAccordion" [destroyOnHide]="false">
                                <div
                                    [ngbAccordionItem]="group.name"
                                    [destroyOnHide]="false"
                                    [collapsed]="isGroupCollapsed(group.name)"
                                    (shown)="setGroupCollapsed(group.name, false)"
                                    (hidden)="setGroupCollapsed(group.name, true)"
                                >
                                    <h2 ngbAccordionHeader class="position-relative">
                                        <button ngbAccordionButton class="lead px-0 border-bottom collapse-title">{{t(group?.name | documentTypeSectionName) | titlecase}}
                                        </button>
                                        @if(group?.name === 'document_field'){
                                            <div *ngIf="documentData | isDocumentEditable" class="addDocumentFieldIcon"
                                                placement="auto" container="body" (click)="openMetaDataModal(0, 1)"
                                                [autoClose]="true" triggers="hover"
                                                [ngbTooltip]="t('Document sidebar tooltip title text (Template/Document - section) - Add Document Fields')">
                                                <i data-feather="plus-circle" class="font-medium-4 mb-25 cursor-pointer"></i>
                                            </div>
                                        }
                                    </h2>
                                    <div ngbAccordionCollapse class="p-0 mt-50">
                                        <div ngbAccordionBody class="px-0 pb-0">
                                            <ng-template ngbNavContent>
                                                @if(group?.name === 'signature'){
                                                    <app-signature-request-section 
                                                        [group]="group" 
                                                        [formGroup]="signatureSectionForm"
                                                        [documentData]="documentData"
                                                        (updateDocument)="onSignatureSectionUpdate($event)"
                                                        [hasFullAccessToDocument]="hasFullAccessToDocument" 
                                                        [canEditDocument]="canEditDocument">
                                                    </app-signature-request-section>
                                                }
                                                @if(group?.name === 'document_field'){
                                                    <div class="drag" cdkDropList (cdkDropListDropped)="onDragEnd($event)">
                                                        @for (docField of fields_data | sortByOrder: 'order'; track docField.uuid) {
                                                        <div class="draggable-field" cdkDrag [cdkDragData]="docField">
                                                            <app-meta-data-fields-list 
                                                                [documentData]="documentData" 
                                                                [field]="docField"
                                                            ></app-meta-data-fields-list>
                                                        </div>
                                                        }
                                                    </div>
                                                }
                                                @if(group?.name === 'details'){
                                                    <app-details-section 
                                                        [group]="group" 
                                                        [formGroup]="detailsSectionForm"
                                                        [hasFullAccessToDocument]="hasFullAccessToDocument" 
                                                        [canEditDocument]="canEditDocument"
                                                        sectionName="send-document"
                                                        [shouldShowDueDateField]="true"
                                                        (updateDocument)="onDetailsSectionUpdate($event)"
                                                        [isDueDateDisabled]="isDueDateDisabled" 
                                                        [disableFlatpickr]="disableFlatpickr" 
                                                        [documentData]="documentData"
                                                        >
                                                    </app-details-section>
                                                }
                                                @if(group.name === 'document'){
                                                    <div class="col-12 p-0">
                                                        <div class="documentTabThumbnailContainer mt-1 px-2">
                                                            <a href="javascript:void(0)" (click)="openFullScreen()">
                                                                <div class="d-flex justify-content-center px-2 py-1 document-thumbnail-box cursor-pointer">
                                                                    <ng-container *ngIf="documentData?.template_details?.document_key; else documentProtected">
                                                                        <img src="/assets/images/document_protected.jpg" alt="" />
                                                                    </ng-container>
                                                                    <ng-template #documentProtected>
                                                                        <img [src]="documentData?.template?.id | thumbnail : 'documents' "
                                                                            alt="" />
                                                                    </ng-template>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </div>
                                                }
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div> 
            }
        </div>
    </ng-scrollbar>
</ng-container>
